import axiosInstance from './AxiosInstance';
import { store } from '../store/store';

export function getInvoices() {
    return axiosInstance.get(`vendor/invoices?branch=1`);
}


export function getSelectedItem(id) {
    return axiosInstance.get(`admin/items/show?id=` + id);
}
